import React from 'react';
import { IconHolder } from './styles';
export default function ModalIconSection({
  children
}) {
  return <IconHolder data-testid="holder-doc">{children}</IconHolder>;
}